/* Gas logs / fireplaces: reveal the existing fuel controls and explain missing
   required choices. Native selection, prices, availability and commerce own state. */
(function () {
  'use strict';
  function init() {
    var page = document.querySelector('.ef-lab-gas-page, .ef-lab-fireplace-page');
    var root = page && page.querySelector('#efOf');
    if (!root || root.dataset.efLabGuidance) return;
    root.dataset.efLabGuidance = 'ready';
    root.classList.add('ef-lab-ordering');
    var fireplace = page.classList.contains('ef-lab-fireplace-page');
    var fuel = null;
    var total = root.querySelector('#efOfTotal');
    var pending = document.createElement('div');
    pending.className = 'ef-lab-order-pending';
    pending.hidden = true;
    var notice = document.createElement('p');
    notice.id = 'efLabOrderPendingText';
    notice.setAttribute('role', 'status');
    notice.setAttribute('aria-live', 'polite');
    var jump = document.createElement('button');
    jump.type = 'button';
    jump.className = 'ef-lab-order-jump';
    pending.append(notice, jump);
    if (total && total.parentNode) total.parentNode.insertBefore(pending, total);
    // Keep the engine's existing live message next to the price it explains.
    var commerceMessage = root.querySelector('#efOfMsg');
    if (total && total.parentNode && commerceMessage && root.dataset.efFamilyFlow !== 'ready') total.parentNode.insertBefore(commerceMessage, total);
    var missing = [];
    jump.addEventListener('click', function () {
      var detail = missing[0];
      if (!detail) return;
      for (var parent = detail.parentElement; parent && parent !== root; parent = parent.parentElement) {
        if (parent.tagName === 'DETAILS') parent.open = true;
      }
      detail.open = true;
      var target = detail.dataset.efLabInlineFuel === 'true'
        ? detail.querySelector('.ef-of__cd-opt:not([disabled]):not([aria-disabled="true"]):not(.ef-of__cd-opt--unavail)')
        : detail.querySelector('summary');
      if (target) target.focus({ preventScroll: true });
      detail.scrollIntoView({ block: 'center', behavior: 'auto' });
    });
    function setText(node, value) { if (node && node.textContent !== value) node.textContent = value; }
    function addHint(field, text, key) {
      if (!field || field.querySelector('[data-ef-lab-hint="' + key + '"]')) return;
      var hint = document.createElement('p');
      hint.className = 'ef-lab-order-hint';
      hint.dataset.efLabHint = key;
      hint.textContent = text;
      var legend = field.querySelector('legend');
      if (legend) legend.insertAdjacentElement('afterend', hint);
      else field.prepend(hint);
    }
    function bindFuel(nextFuel) {
      fuel = nextFuel;
      if (!fuel || fuel.dataset.efLabFuelBound) return;
      fuel.dataset.efLabFuelBound = 'true';
      var control = fuel;
      addHint(fuel.closest('fieldset'), root.dataset.productHandle === '24-fire-pit-gas-log-set-formation-creation' ? 'Match the fuel supply at your outdoor fire pit.' : 'Match the fuel supply at your fireplace.', 'fuel');
      fuel.addEventListener('toggle', function () {
        // The native handler closes its dropdown after selection. These same
        // cards stay visible in the inline treatment; all other dropdowns behave normally.
        if (control.dataset.efLabInlineFuel === 'true' && !control.open) control.open = true;
      });
      fuel.addEventListener('click', function (event) {
        var option = event.target.closest('.ef-of__cd-opt');
        if (!option || option.disabled || option.getAttribute('aria-disabled') === 'true' || option.classList.contains('ef-of__cd-opt--unavail')) return;
        // Native selection runs later in this click's bubbling path and can
        // replace the focused card. Restore focus in the next task, after that
        // dispatch, without waiting for a renderer frame (which can be delayed).
        setTimeout(function () {
          if (!control.isConnected || control.dataset.efLabInlineFuel !== 'true') return;
          var active = document.activeElement;
          if (active && active !== document.body && !control.contains(active)) return;
          if (!control.open) control.open = true;
          var selected = control.querySelector('.ef-of__cd-opt[aria-selected="true"]');
          if (selected) selected.focus({ preventScroll: true });
        }, 0);
      });
    }
    var siblingSizes = root.querySelector('.ef-of__field--gl-size');
    addHint(siblingSizes, 'Choose a size first, then review its fuel and ignition options. The total updates for your selected configuration.', 'sizes');
    function label(detail) {
      var legend = detail.closest('fieldset')?.querySelector('legend');
      if (!legend) return 'required option';
      return legend.textContent.replace(/^\s*\d+\s*/, '').trim();
    }
    function sync() {
      bindFuel(root.querySelector('#efOfCd_fuel'));
      // Native multi-axis set prices are not additive option surcharges. The
      // engine owns the exact total; hide misleading per-axis legacy deltas.
      var nativeSet = window.EF_GL && window.EF_GL[root.dataset.productHandle];
      if (!fireplace && nativeSet && !nativeSet.bareBase) {
        (nativeSet.options || []).forEach(function (axis) {
          var group = root.querySelector('.ef-of__cd[data-group="' + axis.key + '"]');
          if (group) {
            var legacyPrice = root.dataset.efOptionPrices !== 'contextual' ? 'true' : 'false';
            if (group.dataset.efLabSetPrice !== legacyPrice) group.dataset.efLabSetPrice = legacyPrice;
          }
        });
      }
      if (fuel) {
        var cards = fuel.querySelectorAll('.ef-of__cd-opt');
        if (root.dataset.efFamilyFlow === 'ready') {
          // Guided steps own the visible photo cards; keep native pricing guidance below.
          if (fuel.dataset.efLabInlineFuel) delete fuel.dataset.efLabInlineFuel;
        } else if (cards.length > 1 && cards.length <= 3) {
          if (fuel.dataset.efLabInlineFuel !== 'true') {
            fuel.dataset.efLabInlineFuel = 'true';
            var list = fuel.querySelector('[role="listbox"]');
            if (list && !list.getAttribute('aria-label')) list.setAttribute('aria-label', 'Fuel supply');
          }
          if (!fuel.open) fuel.open = true;
          cards.forEach(function (card) {
            // Only simplify the visible label. Native raw labels and option data
            // still resolve the exact variant. Preserve the original restriction.
            if (card.dataset.rawLabel === 'Propane(Match Lit is Not Available)') {
              setText(card.querySelector('.ef-cfg-card__title'), 'Propane (LP)');
              setText(card.querySelector('.ef-cfg-card__desc'), 'Tank supply. Match-lit ignition is not available.');
            }
          });
        } else if (fuel.dataset.efLabInlineFuel === 'true') {
          delete fuel.dataset.efLabInlineFuel;
          fuel.open = false;
        }
      }
      missing = Array.from(root.querySelectorAll('.ef-of__cd[data-required="true"]')).filter(function (d) {
        var field = d.closest('fieldset');
        if (d.dataset.selected === 'true' || !field || field.closest('[hidden]')) return false;
        for (var ancestor = field; ancestor; ancestor = ancestor.parentElement) {
          if (getComputedStyle(ancestor).display === 'none') return false;
          if (ancestor === root) break;
        }
        return true;
      });
      if (pending.hidden !== !missing.length) pending.hidden = !missing.length;
      if (missing.length) {
        setText(notice, missing.length === 1 ? 'One required choice remains. The total may change.' : missing.length + ' required choices remain. The total may change.');
        setText(jump, 'Choose ' + label(missing[0]) + ' →');
      }
      // A collapsed accessories panel tells the customer when paid add-ons are selected.
      if (fireplace) {
        var extras = root.querySelector('.ef-lab-fireplace-extras');
        if (extras) {
          var chosen = Array.from(extras.querySelectorAll('.ef-of__cd')).filter(function (d) {
            var option = d.querySelector('.ef-of__cd-opt[aria-selected="true"]');
            return option && Number(option.dataset.price) > 0;
          });
          setText(extras.querySelector('summary > span'), chosen.length ? chosen.length + ' selected: ' + chosen.map(label).join(', ') : 'Optional add-ons for this fireplace');
        }
      }
    }
    var scheduled = false;
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () { scheduled = false; sync(); });
    }
    sync();
    new MutationObserver(schedule).observe(root, {
      childList: true, subtree: true, attributes: true,
      attributeFilter: ['data-selected', 'data-required', 'aria-selected', 'hidden', 'style']
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
